/// <amd-module name="Wiki/CreateWit/SelectionElements" />

export class SelectionElements {
    public witTables: number = 0;
    public prMentions: number = 0;
    public witMentions: number = 0;
    public peopleMentions: number = 0;
    public htmlTags: { [key: string]: number } = {};
    public lastTextNode: Node; // Last node in the selection which is of type text
    public exploredTextCharCount: number = 0; // count of chars explored while inspecting selection

    /**
     * Inspect the wikiElement param properties and checks if there is any tags which are not allowed and return accordingly.
     */
    public shouldEmbedWorkItem(): boolean {
        if (this.witTables || this.prMentions || this.witMentions || this.peopleMentions || !this._hasOnlyWhiteListedHTMLTags()) {
            return false;
        }
        return true;
    }

    // Resets the object
    public reset(): void {
        this.witTables = 0;
        this.prMentions = 0;
        this.witMentions = 0;
        this.peopleMentions = 0;
        this.htmlTags = {};
        this.exploredTextCharCount = 0;
    }

    // Add/increment the count from the wikiElements param
    public merge(wikiElements: SelectionElements): void {
        this.witTables += wikiElements.witTables;
        this.prMentions += wikiElements.prMentions;
        this.witMentions += wikiElements.witMentions;
        this.peopleMentions += wikiElements.peopleMentions;
        for (const key of Object.keys(wikiElements.htmlTags)) {
            let count = wikiElements.htmlTags[key];
            if (this.htmlTags[key]) {
                // Add the existing count
                count += this.htmlTags[key];
            }
            this.htmlTags[key] = count;
        }
    }

    private _hasOnlyWhiteListedHTMLTags(): boolean {
        // Only supporting text selection with bold and italic in between.
        // (BR, P, DIV, SPAN are added because selection can span multiple lines/para)
        const whileListedHTMLTags = ["BR", "STRONG", "B", "EM", "I", "DIV", "SPAN", "P"];
        let count = 0;
        whileListedHTMLTags.forEach(x => {
            if (this.htmlTags[x]) {
                count++;
            }
        });
        return Object.keys(this.htmlTags).length === count;
    }
}
